import { component } from 'picoapp';
import Modal from 'utils/modal';

export default component(async (node) => {
  const modalElement = node.querySelector<HTMLElement>('[data-modal]');
  const video = modalElement.querySelector('video');

  const modal = Modal(modalElement);
  const trigger = node.querySelector(`a[href="#video-${modalElement.dataset.modal}"]`);

  const loadVideo = () => {
    const source = video.getAttribute('data-src');

    if (source) {
      video.setAttribute('src', source);
      video.removeAttribute('data-src');
    }
  }

  trigger.addEventListener('click', () => {
    modal.open();

    loadVideo();
    video.play();
  });

  modal.on('close', () => {
    video.pause();
  });
});
